import {
  Component,
  forwardRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import {ControlValueAccessor, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {IoniconsOutline, WidgetValidator} from '@pt/pt-models';
import {WidgetTreatmentDataInterestedV0Response} from '../models/widget-treatment-data-interested-v0-response';
import {ValidatorGenerator} from '../../../../utils/validator-generator';
import { TreeNode } from '@pt/tree';

@Component({
  selector: 'pt-widget-treatment-data-interested-v0-group-checkbox',
  templateUrl: './widget-treatment-data-interested-v0-group-checkbox.component.html',
  styleUrls: ['./widget-treatment-data-interested-v0-group-checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => WidgetTreatmentDataInterestedV0GroupCheckboxComponent)
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => WidgetTreatmentDataInterestedV0GroupCheckboxComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None
})
export class WidgetTreatmentDataInterestedV0GroupCheckboxComponent implements OnInit, OnDestroy, OnChanges, ControlValueAccessor {
  @Input() id;
  @Input() controlName: string;
  @Input() title: string;
  @Input() checkboxs: WidgetTreatmentDataInterestedV0Response[];
  @Input() validators: WidgetValidator[];
  @Input() preview: boolean;
  treeData: TreeNode[];
  actualValue: string[];
  checkboxPreview: WidgetTreatmentDataInterestedV0Response[];
  loading = false;
  IconCheck = IoniconsOutline.check;
  IconClose = IoniconsOutline.close;
  public formGroup: FormGroup;
  isChangedValue = false;
  loadingTree = true;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private onChanged: (val) => void;
  private onTouched: () => void;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.checkboxs) {
      this.initTreeData();
    }
  }

  changeSelectedNode(nodes: TreeNode[]) {
    this.actualValue = [];
    nodes.forEach(n => {
      n.children?.forEach(c => {
        if (c.checked) {
          this.actualValue.push(c.uuid);
        }
      })
    })

    Object.keys(this.formGroup.controls).forEach((controlName) => {
      this.formGroup.controls[controlName].setValue(this.actualValue.includes(controlName));
    });
  }


  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  ngOnInit(): void {
    this.setFormGroup();
    this.initTreeData();

    this.formGroup.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(t => {
      this.isChangedValue = t !== null;
      const checkedUUID = this.getListCheckedUUID(t);
      if (this.onChanged) {
        this.onChanged(checkedUUID);
      }
      if (this.onTouched) {
        this.onTouched();
      }
    });

    this.checkboxPreview = this.checkboxs?.filter((c) => c.checked);
  }

  writeValue(obj: string[]): void {
    // NON UTILIZZATO
    // this.formGroup.controls.value.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formGroup.disable();
    } else {
      this.formGroup.enable();
    }
  }

  validate(value: FormControl) {
    return this.formGroup.invalid && {
      invalid: true
    };
  }

  private getListCheckedUUID(t) {
    const response: string[] = [];
    Object.keys(t)?.forEach((k) => {
      if (t[k]) {
        response.push(k);
      }
    });
    return response;
  }

  private setFormGroup() {
    this.loading = true;
    const validator = ValidatorGenerator.generateFromGroupValidator(this.validators);
    this.formGroup = new FormGroup({}, validator);
    this.checkboxs?.forEach(v => {
      if (v.uuid) {
        this.formGroup.addControl(v.uuid, new FormControl(v.checked));
      }
    });
    this.loading = false;
  }

  private initTreeData() {
    this.loadingTree = true;
    this.treeData = [];
    const category = [];
    this.checkboxs?.forEach((c) => {
      if (c.category && !category.includes(c.category)) {
        category.push(c.category);
      }
    });
    category?.forEach((cat: string) => {
      const children: TreeNode[] = this.checkboxs.filter((c) => c.category === cat).map((c) => {
        return {
          uuid: c.uuid,
          label: c.label,
          help: c.help,
          checked: c.checked
        };
      });
      this.treeData.push({
        uuid: cat,
        label: cat,
        help: null,
        checked: false,
        children: children ? children : null
      });
    });


    this.loadingTree = false;
  }

}

//
// interface WidgetGroupCheckboxNodeV0Dto {
//   uuid: string;
//   label: string;
//   help: string;
//   checked: boolean;
//   children?: WidgetGroupCheckboxNodeV0Dto[];
// }
